import { AccessLevel } from "@/api/williams/users";
import { Associations } from "./Associations";
import { Certifications, Welders } from "../../welders";
import { ConfirmationDialog } from "@/components/dialogs";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { getFullPath, routes } from "../../routes";
import { IconButton } from "../../components";
import { IncompleteItems } from "../../search";
import { Metrics } from "./Metrics";
import { Project } from "@/api/williams/project";
import { ProjectDetails } from "./ProjectDetails";
import { ScopesOfWork } from "../../scopeOfWork";
import { TestEvents } from "../../testEvents/components";
import { useDeleteProject } from "../hooks";
import { useModalDialog } from "@/hooks";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../users/hooks";

export function Dashboard({ project }: { project: Project }) {
  const dialog = useModalDialog();
  const deleteProject = useDeleteProject();
  const permissions = usePermissions();
  const navigate = useNavigate();

  const accessLevel = permissions.data?.accessLevel ?? AccessLevel.GeneralUser;

  function handleEditProject() {
    navigate(getFullPath(routes.project.edit(project.id)));
  }

  function handleDeleteProject() {
    dialog.show(ConfirmationDialog, {
      caption: "Delete Project",
      message: "Are you sure you want to delete this project?",
      onAccept: () => {
        deleteProject.mutate(project, {
          onSuccess: () => navigate(getFullPath(routes.project.list)),
        });
      },
    });
  }

  return (
    <>
      <div className="d-md-flex justify-content-between mb-2">
        <h3>Project Dashboard</h3>
        {accessLevel !== AccessLevel.GeneralUser &&
          (project.addedFrom === "Manual" || accessLevel === AccessLevel.Administrator) && (
            <div className="d-flex gap-2 my-auto">
              <IconButton icon={faPenToSquare} title="Edit" onClick={handleEditProject} />
              {accessLevel >= AccessLevel.AIWeldingSME && (
                <IconButton icon={faTrashAlt} title="Delete" onClick={handleDeleteProject} />
              )}
            </div>
          )}
      </div>

      <div className="card mb-3">
        <div className="card-header">Project Details</div>
        <div className="card-body" style={{ maxWidth: 1000 }}>
          <ProjectDetails project={project} />
        </div>
      </div>

      <ul className="mb-5">
        <li className="mb-3">
          <Metrics projectId={project.id} />
        </li>
        <li className="mb-3">
          <Associations projectId={project.id} />
        </li>
        <li className="mb-3">
          <IncompleteItems filters={{ projectId: project.id }} />
        </li>
        <li className="mb-3">
          <ScopesOfWork filters={{ projectId: project.id }} project={project} />
        </li>
        <li className="mb-3">
          <TestEvents filters={{ projectId: project.id }} project={project} />
        </li>
        <li className="mb-3">
          <Welders filters={{ projectId: project.id }} />
        </li>
        <li className="mb-3">
          <Certifications filters={{ projectId: project.id }} />
        </li>
      </ul>
    </>
  );
}
